import type { Column } from "@src/sharedComponents/Table/Types";

import type { TransitionTableColumns } from "./TransitionsTable";

export const createTableColumns = (): Column<TransitionTableColumns>[] => {
  return [
    {
      label: "Team",
      accessor: "team",
      sortable: false,
    },
    {
      label: "Advisors",
      accessor: "advisors",
      sortable: false,
    },
    {
      label: "Launch Date",
      accessor: "launchDate",
      sortable: false,
    },
    {
      label: "Onboarding Status",
      accessor: "onboardingStatus",
      sortable: false,
    },
    {
      label: "Transition Status",
      accessor: "transitionStatus",
      sortable: false,
    },
    {
      label: "Sentiment",
      accessor: "sentiment",
      sortable: false,
    },
    {
      label: "Transitioned AUM",
      accessor: "transitionedAUM",
      sortable: false,
    },
  ];
};
